import { Directive, Input } from '@angular/core';
import { AbstractControl, Validator, NG_VALIDATORS } from '@angular/forms';
import { regExpValidator } from './CustomValidators';

@Directive({
  selector: '[phoneCheck]',
  providers: [{provide: NG_VALIDATORS, useExisting: PhoneValidatorDirective, multi: true}]
})
export class PhoneValidatorDirective implements Validator {
  
  validate(control: AbstractControl): {[key: string]: any} {
    const re = /^((\+[0-9]+)|[0-9]+)((\s[0-9])|[0-9])*$/;

    return regExpValidator(re)(control);
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/utils/validators/phone-directive.ts